import { GAME_KEYS } from "@/store/game/game.constants"

export const GAME_LABELS = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: {
    name: "League of Legends",
    platforms: {
      pc: "PC",
    },
    regions: {
      NA: "North America",
      EUW: "Europe West",
      EUNE: "Europe Nordic & East",
      LAN: "Latin America North",
      LAS: "Latin America South",
      BR: "Brazil",
      OCE: "Oceania",
      RU: "Russia",
      TR: "Turkey",
      JP: "Japan",
      SEA: "South East Asia",
      KR: "Korea",
      CN: "China",
      ME: "Middle East",
    },
    specializations: {
      top: "Top",
      ad: "AD Carry",
      support: "Support",
      mid: "Mid",
      jungle: "Jungle",
    },
  },
  [GAME_KEYS.FORTNITE]: {
    name: "Fortnite",
    platforms: {
      pc: "PC",
      console: "Console",
      mobile: "Mobile",
    },
    regions: {
      NAE: "North America East",
      NAW: "North America West",
      EU: "Europe",
      OCE: "Oceania",
      ME: "Middle East",
      AS: "Asia",
      BR: "Brazil",
    },
    specializations: {
      building: "Building",
      aiming: "Aiming",
      decision: "Decision Making",
    },
  },
  [GAME_KEYS.FORTNITE]: {
    name: "Overwatch",
    platforms: {
      pc: "PC",
      console: "Console",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      dps: "DPS/Damage",
      tank: "Tank",
      support: "Support",
    },
  },
  [GAME_KEYS.CSGO]: {
    name: "CS:GO",
    platforms: {
      pc: "PC",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      awper: "AWP",
      utility: "Utility",
      communication: "Communication",
    },
  },
  [GAME_KEYS.DOTA2]: {
    name: "Dota 2",
    platforms: {
      pc: "PC",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      carry: "Carry",
      offlane: "Offlane",
      mid: "Mid",
      support: "Support",
    },
  },
  [GAME_KEYS.SSBU]: {
    name: "Super Smash Bros. Ultimate",
    platforms: {
      console: "Console",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      heavy: "Heavies",
      sword: "Swordies",
      projectile: "Projectile",
      rushdown: "Rush Down",
    },
  },
  [GAME_KEYS.WOW]: {
    name: "World of Warcraft",
    platforms: {
      pc: "PC",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      raiding: "Raiding",
      pvp: "PvP",
      leveling: "Leveling",
      warrior: "Warrior",
      paladin: "Paladin",
      hunter: "Hunter",
      rogue: "Rogue",
      priest: "Priest",
      death_knight: "Death Knight",
      shaman: "Shaman",
      mage: "Mage",
      warlock: "Warlock",
      monk: "Monk",
      druid: "Druid",
      demon_hunter: "Demon Hunter",
    },
  },
  [GAME_KEYS.HEARTHSTONE]: {
    name: "Hearthstone",
    platforms: {
      pc: "PC",
      mobile: "Mobile",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      aggro: "Aggro",
      combo: "Combo",
      midrange: "Midrange",
      control: "Control",
    },
  },
  [GAME_KEYS.MTG]: {
    name: "Magic: The Gathering",
    platforms: {
      pc: "PC",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      aggro: "Aggro",
      combo: "Combo",
      midrange: "Midrange",
      control: "Control",
    },
  },
  [GAME_KEYS.CLASH_ROYALE]: {
    name: "Clash Royale",
    platforms: {
      mobile: "Mobile",
    },
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      deckbuilding: "Deck Building",
      execution: "Gameplay",
    },
  },
}

export const INSTAPRO_LANGUAGES = {
  eng: {
    name: "English",
  },
  afr: {
    name: "Afrikaans",
  },
  alb: {
    name: "Albanian",
  },
  ara: {
    name: "Arabic",
  },
  chi: {
    name: "Chinese",
  },
  hrv: {
    name: "Croatian",
  },
  cze: {
    name: "Czech",
  },
  dan: {
    name: "Danish",
  },
  dut: {
    name: "Dutch",
  },
  est: {
    name: "Estonian",
  },
  fil: {
    name: "Filipino",
  },
  fin: {
    name: "Finnish",
  },
  fre: {
    name: "French",
  },
  ger: {
    name: "German",
  },
  gle: {
    name: "Irish",
  },
  gre: {
    name: "Greek",
  },
  hin: {
    name: "Hindi",
  },
  hun: {
    name: "Hungarian",
  },
  ind: {
    name: "Indonesian",
  },
  ita: {
    name: "Italian",
  },
  jpn: {
    name: "Japanese",
  },
  kor: {
    name: "Korean",
  },
  lit: {
    name: "Lithuanian",
  },
  mac: {
    name: "Macedonian",
  },
  may: {
    name: "Malay",
  },
  nor: {
    name: "Norwegian",
  },
  per: {
    name: "Persian",
  },
  phi: {
    name: "Philippine languages",
  },
  pol: {
    name: "Polish",
  },
  por: {
    name: "Portuguese",
  },
  rum: {
    name: "Romanian",
  },
  rus: {
    name: "Russian",
  },
  slv: {
    name: "Slovenian",
  },
  spa: {
    name: "Spanish",
  },
  srp: {
    name: "Serbian",
  },
  swa: {
    name: "Swahili",
  },
  swe: {
    name: "Swedish",
  },
  tha: {
    name: "Thai",
  },
  tur: {
    name: "Turkish",
  },
  vie: {
    name: "Vietnamese",
  },
}

export const DEFAULT_REGIONS = {
  NA: {
    name: "North America",
  },
  EU: {
    name: "Europe",
  },
  BR: {
    name: "Brazil",
  },
  JP: {
    name: "Japan",
  },
  OCE: {
    name: "Oceania",
  },
  KR: {
    name: "Korea",
  },
}

export const PLATFORMS = {
  pc: {
    name: "PC",
  },
  console: {
    name: "Console",
  },
  ps4: {
    name: "PS4",
  },
  pst: {
    name: "PSt",
  },
  xbox: {
    name: "XBOX",
  },
  xbox_one: {
    name: "Xbox One",
  },
  xbox_series_x: {
    name: "Xbox Series X",
  },
  switch: {
    name: "Nintendo Switch",
  },
  stadia: {
    name: "Google Stadia",
  },
}

export const GAME_USERNAME_LABELS = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "Summoner Name",
  [GAME_KEYS.FORTNITE]: "Fortnite Username",
  [GAME_KEYS.SSBU]: "Smash Username",
  [GAME_KEYS.OVERWATCH]: "Battlenet Username",
  [GAME_KEYS.TEAMFIGHT_TACTICS]: "Summoner Name",
  [GAME_KEYS.HEARTHSTONE]: "Battlenet Username",
  [GAME_KEYS.CSGO]: "Steam Username",
}

export const COACH_COMMUNICATION_METHODS = {
  DISCORD: "discord",
  SKYPE: "skype",
}

export const COACH_SEARCH_FILTERS = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  FAVORITE: "FAVORITE",
  HAS_CUSTOM_SESSION_TYPES: "HAS_CUSTOM_SESSION_TYPES",
  HAS_OPEN_SCHEDULE_SLOTS: "HAS_OPEN_SCHEDULE_SLOTS",
  ONLINE_OR_HAS_OPEN_SCHEDULE_SLOTS: "ONLINE_OR_HAS_OPEN_SCHEDULE_SLOTS",
  FEATURED: "FEATURED",
  NOT_FEATURED: "NOT_FEATURED",
  AVAILABLE_THIS_WEEK: "THIS_WEEK",
  AVAILABLE_THIS_MONTH: "THIS_MONTH",
  WITH_PROFILE_PAGE: "WITH_PROFILE_PAGE",
}

export const COACH_SEARCH_SORT_OPTIONS = {
  AVAILABLE_FIRST: "AVAILABLE_FIRST",
  MOST_POPULAR: "MOST_POPULAR",
  ALPHABETICAL: "ALPHABETICAL",
  NEWEST_FIRST: "NEWEST_FIRST",
  CUSTOM_SESSION_TYPES_FIRST: "CUSTOM_SESSION_TYPES_FIRST",
}

export const SERVICE_CATEGORIES = {
  SESSIONS: "sessions",
  CUSTOM_SERVICES: "custom-services",
  SUBSCRIPTIONS: "subscriptions",
  BUNDLES: "bundles",
}

export const SERVICE_SCHEDULING_LEAD_TIME_IN_MINS = 180

export const PAYMENT_METHODS = {
  PG_POINTS: "PG_POINTS",
  PB_CREDIT: "PB_CREDIT",
}

export const COACH_SERVICE_CHECKOUT_FLOWS = {
  COACH_PROFILE: "coach-profile",
  COACH_WIDGET: "coach-widget",
}

export const COACHIFY_MAP = {
  "2465988": "wa1ve",
  //  "38424": "scuba123",
  "27097": "danzo",
  "131621": "path",
  "224833": "akemi",
  "2480145": "paragon",
  "2648096": "ernzxr",
  "44771": "modorenai",
  "1131736": "phoenixkola",
  "930146": "namesroach",
  "2818533": "madoka",
  "2532398": "drafor",
  "570393": "betatwins",
  "1494621": "seewigg",
  "136": "krazyness",
  "1824005": "settios",
  "1554176": "toastyunicorns",
  "1227993": "coutu",
  "1444340": "liakopoulos",
  "481528": "epicreaper",
  "1549095": "emad",
  "2554233": "loers",
  "2395369": "jland",
  "2924209": "busterval",
  "2568653": "doinks",
  "617068": "krispyyzx",
  "2362504": "cloudz",
  "764192": "sycu",
  "2600732": "naughty",
  "2811129": "diaamond",
  "1494429": "coachkux",
  "364550": "proguideslordxav1er",
  "1561182": "determination",
  "2124961": "darc",
  "2512423": "baula",
  "398014": "redfr4me",
  "578546": "floxy",
  "2004012": "shatteruu",
  "2282474": "lol0utlaw",
  "2981990": "unidaro"
}



// WEBPACK FOOTER //
// ./src/store/coaching/coaching.constants.js